/* eslint-disable react/no-array-index-key */
import React, { useEffect, useMemo, useState } from 'react';
import { Image } from 'antd-v5';
import './styles.scss';

const NOT_FOUND_IMAGE = 'https://dashboard-v2-images.s3.amazonaws.com/not-found.png';

const Carousel = props => {
  const { images, isClientPage, getImageUrl } = props;

  if (!images.length) {
    return <Image src={NOT_FOUND_IMAGE} fallback={NOT_FOUND_IMAGE} alt="Product" />;
  }

  const primaryImage = useMemo(() => images.find(image => image.isPrimary) || images[0], [images]);

  const [selectedImage, setSelectedImage] = useState(primaryImage);

  useEffect(() => {
    setSelectedImage(primaryImage);
    getImageUrl(primaryImage?.url || NOT_FOUND_IMAGE);
  }, [primaryImage]);

  const handleSelectImage = image => {
    setSelectedImage(image);
    getImageUrl(image.url || NOT_FOUND_IMAGE);
  };

  return (
    <div className="cb-carousel">
      <div className={`cb-carousel__preview${isClientPage ? '-client-page' : ''}`}>
        <Image src={selectedImage.url || NOT_FOUND_IMAGE} fallback={NOT_FOUND_IMAGE} alt="Product" />
      </div>

      <div className="cb-carousel__track">
        {images.map((image, index) => (
          <Image
            key={`${image.url}-${index}`}
            src={image.url || NOT_FOUND_IMAGE}
            fallback={NOT_FOUND_IMAGE}
            preview={false}
            onClick={() => handleSelectImage(image)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
